import { Generator } from "@visactor/vrender-core/common/generator";

import { BaseWindowHandlerContribution, WindowHandlerContribution } from "@visactor/vrender-core";

import { NodeCanvas } from "../../canvas/contributions/node";

import { application } from "@visactor/vrender-core/application";

export class NodeWindowHandlerContribution extends BaseWindowHandlerContribution {
    get container() {
        return null;
    }
    constructor(global = application.global) {
        super(), this.global = global, this.type = "node";
    }
    getTitle() {
        return "";
    }
    getWH() {
        return {
            width: this.canvas.displayWidth,
            height: this.canvas.displayHeight
        };
    }
    getXY() {
        return {
            x: 0,
            y: 0
        };
    }
    createWindow(params) {
        params.canvas ? this.createWindowByCanvas(params) : this.createWindowByConfig(params);
    }
    createWindowByConfig(params) {
        const nativeCanvas = this.global.createCanvas({
            width: params.width,
            height: params.height
        }), options = {
            width: params.width,
            height: params.height,
            dpr: params.dpr,
            nativeCanvas: nativeCanvas,
            id: Generator.GenAutoIncrementId().toString(),
            canvasControled: !0
        };
        this.canvas = new NodeCanvas(options);
    }
    createWindowByCanvas(params) {
        var _a;
        const canvas = params.canvas, dpr = null !== (_a = params.dpr) && void 0 !== _a ? _a : 1;
        let width = params.width, height = params.height;
        null != width && null != height && params.canvasControled || (width = canvas.width / dpr, 
        height = canvas.height / dpr), this.canvas = new NodeCanvas({
            width: width,
            height: height,
            dpr: dpr,
            nativeCanvas: canvas,
            canvasControled: params.canvasControled
        });
    }
    releaseWindow() {
        this.canvas.release();
    }
    resizeWindow(width, height) {
        this.canvas.resize(width, height);
    }
    setDpr(dpr) {
        this.canvas.dpr = dpr;
    }
    getContext() {
        return this.canvas.getContext();
    }
    getNativeHandler() {
        return this.canvas;
    }
    getDpr() {
        return this.canvas.dpr;
    }
    getImageBuffer(type = "image/png") {
        return this.canvas.nativeCanvas.toBuffer(type);
    }
    addEventListener(type, listener, options) {}
    dispatchEvent(event) {
        return !0;
    }
    removeEventListener(type, listener, options) {}
    getStyle() {}
    setStyle(style) {}
    getBoundingClientRect() {
        return null;
    }
    clearViewBox(color) {}
}

NodeWindowHandlerContribution.env = "node";

export function bindNodeWindowContribution(container) {
    var _a, _b;
    (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, NodeWindowHandlerContribution)) || container.bind(NodeWindowHandlerContribution).toSelf(), 
    (null === (_b = container.getNamed) || void 0 === _b ? void 0 : _b.call(container, WindowHandlerContribution, NodeWindowHandlerContribution.env)) || container.bind(WindowHandlerContribution).toService(NodeWindowHandlerContribution).whenTargetNamed(NodeWindowHandlerContribution.env);
}
//# sourceMappingURL=node-contribution.js.map
